import React from 'react'
import { useIntl } from 'react-intl'
import { Box, useTheme } from '@mui/material'
import styled from '@emotion/styled'
import { QuestionState } from '../../../../features/types'
import { BoldText } from '../../../../layouts/TextStyles'

interface Props {
    questions: QuestionState[]
}

const ResultNavigation: React.FC<Props> = ({ questions = [] }) => {
    const theme = useTheme()
    const { formatMessage } = useIntl()

    const styles = {
        wrapper: {
            border: `1px solid ${theme.palette.grey[200]}`,
            mb: 2,
            p: 2,
            borderRadius: '8px',
        },
        answered: {
            mb: 2,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            fontWeight: 500,
        },
        questions: {
            display: 'grid',
            gridTemplateColumns: 'repeat(5, auto)',
            alignItems: 'start',
            justifyContent: 'space-between',
            gap: '8px',
        },
    }

    return (
        <Box sx={styles.wrapper}>
            <Box sx={styles.answered}>
                {formatMessage({ id: 'answers' })}:
                {/* {formatMessage({ id: 'answeredQuestions' })}:<Box>4</Box> */}
            </Box>

            <Box sx={styles.questions}>
                {questions.map((question, index) => (
                    <QuestionBox
                        key={index}
                        percentage={question.percentage}
                    >
                        <BoldText color={'white'}>{index + 1}</BoldText>
                    </QuestionBox>
                ))}
            </Box>
        </Box>
    )
}

export default ResultNavigation

const QuestionBox = styled(Box)<{ percentage: number }>`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    border-radius: 4px;
    background: ${(props) =>
        props.percentage <= 50
            ? '#FF507A'
            : props.percentage <= 80
            ? '#FFDF3C'
            : '#59E8B5'};
    cursor: pointer;
    color: white;
`
